import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 19px;\n  text-align: center;\n  opacity: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 96px;\n  display: flex;\n  flex-direction: column;\n  cursor: ", ";\n  justify-content: flex-start;\n  align-items: center;\n  input[type=\"checkbox\"] {\n    display: none;\n    position: relative;\n    right: -999em;\n  }\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    span {\n      border-radius: 6px;\n      width: 96px;\n      height: 96px;\n      background-position: center;\n      border: 1px solid transparent;\n      position: relative;\n      .color-checkbox__icon {\n        &-check,\n        &-cross {\n          position: absolute;\n          top: 6px;\n          right: 6px;\n          width: 20px;\n          height: 20px;\n          border-radius: 50%;\n          background-color: #ca9c66;\n          justify-content: center;\n          align-items: center;\n          display: none;\n          svg {\n            transform: scale(0.5);\n          }\n        }\n      }\n    }\n\n    :focus {\n      outline: none;\n    }\n  }\n\n  ", "\n\n  span {\n    max-width: 96px;\n    font-size: 16px;\n    line-height: 19px;\n  }\n\n  input:checked + div {\n    span {\n      border: 1px solid #c34c3e;\n      .color-checkbox__icon {\n        &-check {\n          display: flex;\n        }\n      }\n    }\n    &:hover {\n      span {\n        .color-checkbox__icon {\n          &-check {\n            display: none;\n          }\n          &-cross {\n            display: flex;\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { styled } from "@styles";
export var ColorCheckbox = styled.div(_templateObject());
export var Label = styled.label(_templateObject2(), function (props) {
  return props.disabled ? "not-allowed" : "pointer";
}, function (props) {
  return props.disabled ? "" : "&:hover {\n          div {\n            opacity: 1;\n            span {\n              .color-checkbox__icon-check {\n                display: flex;\n                background: #d0d3d8;\n                opacity: 0.5;\n                border: 1.5px solid #839098;\n                svg {\n                  display: none;\n                }\n              }\n            }\n          }\n        }";
});
export var Name = styled.div(_templateObject3(), function (props) {
  return props.checked && !props.disabled ? 1 : 0.3;
});